import { Popover, styled } from '@mui/material';

import { IWithCSS } from '/common/models';

export const PopoverStyled = styled(Popover)<IWithCSS>`
  ${({ css }) => css}
`;
